import coverheader from './images/coverheader.jpg'
import vnglogo from './images/vnglogo.png'
import coverheadermobile from './images/coverheadermobile.jpg';
import financialbg from './images/financialbg.png';
import financialbgmobile from './images/financialbgmobile.png';
import FinancialIcon4 from './images/FinancialIcon4.png';
import FinancialIcon3 from './images/FinancialIcon3.png';
import FinancialIcon2 from './images/FinancialIcon2.png';
import FinancialIcon1 from './images/FinancialIcon1.png';
import AwardImage1 from './images/AwardImage1.jpg';
import AwardImage2 from './images/AwardImage2.jpg';
import AwardImage3 from './images/AwardImage3.jpg';
import AwardImage4 from './images/AwardImage4.png';
import AwardImage5 from './images/AwardImage5.png';

import AwardIcon from './images/AwardIcon.png';

import aibackground from './images/aibackground.png'; // hoặc file bạn đã dùng trong ảnh
import aibackgroundmobile from './images/aibackgroundmobile.png'; // hoặc file bạn đã dùng trong ảnh

import aibackground2 from './images/aibackground2.png';
import aibackgroundmobile2 from './images/aibackgroundmobile2.png';
import aibackground3 from './images/aibackground3.png';
import aibackgroundmobile3 from './images/aibackgroundmobile3.png';
import aibackground4 from './images/aibackground4.png';
import aibackgroundmobile4 from './images/aibackgroundmobile4.png'; 

import Footer_iconfacebook from './images/Footer_iconfacebook.png';
import Footer_iconlinkin from './images/Footer_iconlinkin.png';
import Footer_iconweb from './images/Footer_iconweb.png';
import Footer_iconscrolltop from './images/Footer_iconscrolltop.png';
import Footer_logo from './images/Footer_logo.png';


import menu_icon1 from './images/menu_icon1.png';
import menu_icon2 from './images/menu_icon2.png';
import menu_icon3 from './images/menu_icon3.png';
import menu_icon4 from './images/menu_icon4.png';
import menu_icon5 from './images/menu_icon5.png';
import SubBackground from './images/SubBackground.jpg';

import AboutImage1 from './images/AboutImage1.png';
import AboutImage1_vi from './images/AboutImage1_vi.png';

import AboutImage2 from './images/AboutImage2.png';
import about_revenue_chart from './images/about_revenue_chart.png';
import about_revenue_chart_vi from './images/about_revenue_chart_vi.png';
import AboutBottomBacground from './images/AboutBottomBacground.png';
import Game2024Image1 from './images/Game2024Image1.png';
import Game2024Image2 from './images/Game2024Image2.png';
import Game2024Image3 from './images/Game2024Image3.png';
import Game2024Image4 from './images/Game2024Image4.png';
import Game2024Image5 from './images/Game2024Image5.png';
import Game2024Image6 from './images/Game2024Image6.png';
import Game2024Image7 from './images/Game2024Image7.png';

import Game2024Icon1 from './images/Game2024Icon1.png';
import Game2024Icon2 from './images/Game2024Icon2.png';
import Game2024Icon3 from './images/Game2024Icon3.png';
import Game2024Icon4 from './images/Game2024Icon4.png';
import Game2024Icon5 from './images/Game2024Icon5.png';
import Game2024Icon6 from './images/Game2024Icon6.png';


import Zalo2024Image1 from './images/Zalo2024Image1.png';
import Zalo2024Image1_vi from './images/Zalo2024Image1_vi.png';

import Zalo2024Image2 from './images/Zalo2024Image2.png';
import Zalo2024Image2_vi from './images/Zalo2024Image2_vi.png';

import Zalo2024Image3 from './images/Zalo2024Image3.png';
import Zalo2024Image3_vi from './images/Zalo2024Image3_vi.png';

import Zalo2024Icon1 from './images/Zalo2024Icon1.png';
import Zalo2024Icon2 from './images/Zalo2024Icon2.png';
import Zalo2024Icon3 from './images/Zalo2024Icon3.png';


import Zalopay2024Image1 from './images/Zalopay2024Image1.png';
import Zalopay2024Image2 from './images/Zalopay2024Image2.png';
import Zalopay2024Image2_vi from './images/Zalopay2024Image2_vi.png';
import Zalopay2024Image3 from './images/Zalopay2024Image3.png';
import Zalopay2024Image4 from './images/Zalopay2024Image4.png';

import Zalopay2024Icon1 from './images/Zalopay2024Icon1.png';
import Zalopay2024Icon2 from './images/Zalopay2024Icon2.png';
import Zalopay2024Icon3 from './images/Zalopay2024Icon3.png';
import Zalopay2024Icon4 from './images/Zalopay2024Icon4.png';
import Zalopay2024Icon5 from './images/Zalopay2024Icon5.png';



import DigitalBusinessImage1 from './images/DigitalBusinessImage1.png';
import DigitalBusinessImage2 from './images/DigitalBusinessImage2.png';
import DigitalBusinessImage3 from './images/DigitalBusinessImage3.png';

import DigitalBusinessIcon1 from './images/DigitalBusinessIcon1.png';
import DigitalBusinessIcon2 from './images/DigitalBusinessIcon2.png';
import DigitalBusinessIcon3 from './images/DigitalBusinessIcon3.png';
import DigitalBusinessIcon4 from './images/DigitalBusinessIcon4.png';


import VNGPeopleStrategyImage1 from './images/VNGPeopleStrategyImage1.png';
import VNGPeopleStrategyImage1_vi from './images/VNGPeopleStrategyImage1_vi.png';

import VNGPeopleStrategyImage2 from './images/VNGPeopleStrategyImage2.png';
import VNGPeopleStrategyImage2_vi from './images/VNGPeopleStrategyImage2_vi.png';

import VNGPeopleStrategyImage3 from './images/VNGPeopleStrategyImage3.jpg';
import VNGPeopleStrategyImage4 from './images/VNGPeopleStrategyImage4.jpg';
import VNGPeopleStrategyImage5 from './images/VNGPeopleStrategyImage5.jpg';

import VNGPeopleStrategyImage6 from './images/VNGPeopleStrategyImage6.png';
import VNGPeopleStrategyImage6_vi from './images/VNGPeopleStrategyImage6_vi.png';
import VNGPeopleStrategyImage7 from './images/VNGPeopleStrategyImage7.png';
import VNGPeopleStrategyImage7_vi from './images/VNGPeopleStrategyImage7_vi.png';


import VNGPeopleStrategyIcon1 from './images/VNGPeopleStrategyIcon1.png';
import VNGPeopleStrategyIcon2 from './images/VNGPeopleStrategyIcon2.png';
import VNGPeopleStrategyIcon3 from './images/VNGPeopleStrategyIcon3.png';
import VNGPeopleStrategyIcon4 from './images/VNGPeopleStrategyIcon4.png';
import VNGPeopleStrategyIcon5 from './images/VNGPeopleStrategyIcon5.png';

import VNGsApproachToCSRImage1 from './images/VNGsApproachToCSRImage1.png';
import VNGsApproachToCSRImage2 from './images/VNGsApproachToCSRImage2.png';
import VNGsApproachToCSRImage3 from './images/VNGsApproachToCSRImage3.png';
import VNGsApproachToCSRImage4 from './images/VNGsApproachToCSRImage4.png';
import VNGsApproachToCSRImage5 from './images/VNGsApproachToCSRImage5.png';
import VNGsApproachToCSRImage5_vi from './images/VNGsApproachToCSRImage5_vi.png';

import VNGsApproachToCSRImage6 from './images/VNGsApproachToCSRImage6.png';
import VNGsApproachToCSRImage7 from './images/VNGsApproachToCSRImage7.png';
import VNGsApproachToCSRImage8 from './images/VNGsApproachToCSRImage8.png';
import VNGsApproachToCSRImage8_vi from './images/VNGsApproachToCSRImage8_vi.png';

import VNGsApproachToCSRImage9 from './images/VNGsApproachToCSRImage9.png';
import VNGsApproachToCSRImage10 from './images/VNGsApproachToCSRImage10.png';
import VNGsApproachToCSRImage11 from './images/VNGsApproachToCSRImage11.png';
import VNGsApproachToCSRImage11_vi from './images/VNGsApproachToCSRImage11_vi.png';



import DigitalTransformationImage1 from './images/DigitalTransformationImage1.png';
import DigitalTransformationImage2 from './images/DigitalTransformationImage2.png';
import DigitalTransformationImage3 from './images/DigitalTransformationImage3.png';
import DigitalTransformationImage4 from './images/DigitalTransformationImage4.png';
import DigitalTransformationImage5 from './images/DigitalTransformationImage5.png';
import DigitalTransformationImage6 from './images/DigitalTransformationImage6.png';
import DigitalTransformationImage7 from './images/DigitalTransformationImage7.png';
import DigitalTransformationImage8 from './images/DigitalTransformationImage8.png';
import DigitalTransformationImage9 from './images/DigitalTransformationImage9.png';
import DigitalTransformationImage10 from './images/DigitalTransformationImage10.png';
import DigitalTransformationImage11 from './images/DigitalTransformationImage11.png';
import DigitalTransformationImage12 from './images/DigitalTransformationImage12.png';

import CorporateStructureImage1 from './images/CorporateStructureImage1.png';
import CorporateStructureImage1_vi from './images/CorporateStructureImage1_vi.png';


import headerVideoDesktop from './videos/headerVideoDesktop.webm';
import headerVideoMobile from './videos/headerVideoMobile.webm';


import MacroeconomicOverviewImage1 from './images/MacroeconomicOverviewImage1.png';
import MacroeconomicOverviewImage1_vi from './images/MacroeconomicOverviewImage1_vi.png';

import MacroeconomicOverviewImage2 from './images/MacroeconomicOverviewImage2.png';
import MacroeconomicOverviewImage2_vi from './images/MacroeconomicOverviewImage2_vi.png';

import MacroeconomicOverviewImage3 from './images/MacroeconomicOverviewImage3.png';
import MacroeconomicOverviewImage3_vi from './images/MacroeconomicOverviewImage3_vi.png';

import MacroeconomicOverviewImageBG from './images/MacroeconomicOverviewImageBG.png';

import ManagementReport1Image1 from './images/ManagementReport1Image1.png';
import ManagementReport1Image2 from './images/ManagementReport1Image2.png';
import ManagementReport1Image3 from './images/ManagementReport1Image3.png';
import ManagementReport1Image4 from './images/ManagementReport1Image4.png';
import ManagementReport1Image5 from './images/ManagementReport1Image5.png';
import ManagementReport2Image1 from './images/ManagementReport2Image1.png';
import ManagementReport2Image2 from './images/ManagementReport2Image2.png';

import ManagementReport1Image1_vi from './images/ManagementReport1Image1_vi.png';
import ManagementReport1Image2_vi from './images/ManagementReport1Image2_vi.png';
import ManagementReport1Image3_vi from './images/ManagementReport1Image3_vi.png';
import ManagementReport1Image4_vi from './images/ManagementReport1Image4_vi.png';
import ManagementReport1Image5_vi from './images/ManagementReport1Image5_vi.png';
import ManagementReport2Image1_vi from './images/ManagementReport2Image1_vi.png';
import ManagementReport2Image2_vi from './images/ManagementReport2Image2_vi.png';

import ChairmanMessageImage1 from './images/ChairmanMessageImage1.png';
import BannerZaloMobile from './images/BannerZaloMobile.png';

import languageIcon from './images/languageIcon.png';



const resources = {
    images: {
        languageIcon,
        BannerZaloMobile,
        ChairmanMessageImage1,

        ManagementReport2Image1_vi,
        ManagementReport2Image2_vi,
        ManagementReport1Image1_vi,
        ManagementReport1Image2_vi,
        ManagementReport1Image3_vi,
        ManagementReport1Image4_vi,
        ManagementReport1Image5_vi,

        ManagementReport2Image1,
        ManagementReport2Image2,
        ManagementReport1Image1,
        ManagementReport1Image2,
        ManagementReport1Image3,
        ManagementReport1Image4,
        ManagementReport1Image5,
        MacroeconomicOverviewImage1,
        MacroeconomicOverviewImage1_vi,
        MacroeconomicOverviewImage2,
        MacroeconomicOverviewImage2_vi,
        MacroeconomicOverviewImage3,
        MacroeconomicOverviewImage3_vi,
        MacroeconomicOverviewImageBG,
        CorporateStructureImage1,
        CorporateStructureImage1_vi,

        DigitalTransformationImage1,
        DigitalTransformationImage2,
        DigitalTransformationImage3,
        DigitalTransformationImage4,
        DigitalTransformationImage5,
        DigitalTransformationImage6,
        DigitalTransformationImage7,
        DigitalTransformationImage8,
        DigitalTransformationImage9,
        DigitalTransformationImage10,
        DigitalTransformationImage11,
        DigitalTransformationImage12,

        VNGsApproachToCSRImage1,
        VNGsApproachToCSRImage2,
        VNGsApproachToCSRImage3,
        VNGsApproachToCSRImage4,
        VNGsApproachToCSRImage5,
        VNGsApproachToCSRImage5_vi,
        VNGsApproachToCSRImage6,
        VNGsApproachToCSRImage7,
        VNGsApproachToCSRImage8,
        VNGsApproachToCSRImage8_vi,
        VNGsApproachToCSRImage9,
        VNGsApproachToCSRImage10,
        VNGsApproachToCSRImage11,
        VNGsApproachToCSRImage11_vi,

       
        
        VNGPeopleStrategyImage1,
        VNGPeopleStrategyImage1_vi,
        VNGPeopleStrategyImage2,
        VNGPeopleStrategyImage2_vi,
        VNGPeopleStrategyImage3,
        VNGPeopleStrategyImage4,
        VNGPeopleStrategyImage5,
        VNGPeopleStrategyImage6,
        VNGPeopleStrategyImage6_vi,
        VNGPeopleStrategyImage7,
        VNGPeopleStrategyImage7_vi,

        DigitalBusinessImage1,
        DigitalBusinessImage2,
        DigitalBusinessImage3,
        Zalopay2024Image1,
        Zalopay2024Image2,
        Zalopay2024Image2_vi,
        Zalopay2024Image3,
        Zalopay2024Image4,
        Zalo2024Image1,
        Zalo2024Image1_vi,
        Zalo2024Image2,
        Zalo2024Image2_vi,
        Zalo2024Image3_vi,
        Zalo2024Image3,
        Game2024Image1,
        Game2024Image2,
        Game2024Image3,
        Game2024Image4,
        Game2024Image5,
        Game2024Image6,
        Game2024Image7,
        AboutBottomBacground,
        about_revenue_chart,
        about_revenue_chart_vi,
        AboutImage1,
        AboutImage1_vi,
        AboutImage2,
        SubBackground,
        menu_icon1,
        menu_icon2,
        menu_icon3,
        menu_icon4,
        menu_icon5,
        Footer_logo,
        AwardImage1,
        AwardImage2,
        AwardImage3,
        AwardImage4,
        AwardImage5,
        coverheader,
        vnglogo,coverheadermobile,
        financialbg,
        financialbgmobile,
        aibackgroundmobile,
        aibackground,
        aibackgroundmobile2,
        aibackground2,
        aibackgroundmobile3,
        aibackground3,
        aibackgroundmobile4,
        aibackground4,
       
    },
    icons: {
        VNGPeopleStrategyIcon1,
        VNGPeopleStrategyIcon2,
        VNGPeopleStrategyIcon3,
        VNGPeopleStrategyIcon4,
        VNGPeopleStrategyIcon5,
        DigitalBusinessIcon1,
        DigitalBusinessIcon2,
        DigitalBusinessIcon3,
        DigitalBusinessIcon4,
        Zalopay2024Icon1,
        Zalopay2024Icon2,
        Zalopay2024Icon3,
        Zalopay2024Icon4,
        Zalopay2024Icon5,
        Zalo2024Icon1,
        Zalo2024Icon2,
        Zalo2024Icon3,
        Footer_iconfacebook,
        Footer_iconlinkin,
        Footer_iconweb,
        Footer_iconscrolltop,
        AwardIcon,
        FinancialIcon4,
        FinancialIcon3,
        FinancialIcon2,
        FinancialIcon1,
        Game2024Icon1,
        Game2024Icon2,
        Game2024Icon3,
        Game2024Icon4,
        Game2024Icon5,
        Game2024Icon6
    },
    video: {
        headerVideoDesktop,
        headerVideoMobile
    }
}
export default resources